module.exports = __webpack_public_path__ + "img/icon_class.7adc180f.svg";